module.exports = __webpack_public_path__ + "img/avti_4.73475cca.png";